
import React from 'react';
import { Badge } from '@/components/ui/badge';

export const getStatusBadge = (status: string) => {
  switch(status) {
    case 'active':
      return <Badge className="bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300">Active</Badge>;
    case 'inactive':
      return <Badge className="bg-slate-100 text-slate-800 dark:bg-slate-900/20 dark:text-slate-300">Inactive</Badge>;
    case 'maintenance':
      return <Badge className="bg-amber-100 text-amber-800 dark:bg-amber-900/20 dark:text-amber-300">Maintenance</Badge>;
    default:
      return <Badge variant="outline">{status}</Badge>;
  }
};

export const getDepartmentBadge = (department: string) => {
  switch(department.toLowerCase()) {
    case 'energy':
      return <Badge className="bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-300">Energy</Badge>;
    case 'gas':
      return <Badge className="bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-300">Gas</Badge>;
    case 'water':
      return <Badge className="bg-cyan-100 text-cyan-800 dark:bg-cyan-900/20 dark:text-cyan-300">Water</Badge>;
    default:
      return <Badge variant="outline">{department}</Badge>;
  }
};

export const getTypeIcon = (type: string) => {
  switch(type) {
    case 'energy':
      return "⚡"; // Energy icon
    case 'gas':
      return "🔥"; // Gas icon
    case 'water':
      return "💧"; // Water icon
    default:
      return "📱"; // Default device icon
  }
};
